import React, { useEffect } from "react";
import Aos from "aos";
import { BrowserRouter as Router } from "react-router-dom";

import Layout from "./shared/layout/Layout";

import "./shared/assets/global.css";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <div className="App">
      <Router>
        <Layout />
      </Router>
    </div>
  );
};

export default App;
